import React, { useState, useEffect } from "react";
import { useSelector,useDispatch } from "react-redux";
import LoadingSpinner from "../../../components/client/LoadingSpinner";
import OrganicSocialMetricsCard from "./components/OrganicSocialMetricsCard";
import "./css/organic-social-list.css";
import { getImgSrc } from "../../../helpers/getImgSrc";
import { handleApi } from "../../../utils/authentication";
import {getPlatformNameOrId} from "../../../helpers/getPlatformName"
import {UPDATE_FILTER_DATA} from '../../../redux/features/user/filterSlice'

const OrganicSocialList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [organicSocialMetrics, setOrganicSocialMetrics] = useState([]);
  const [isMetricsLoading, setIsMetricsLoading] = useState(false);

  // State for active tab (LinkedIn, Facebook, Instagram)
    const user = useSelector((state) => state?.user);
  const filter = useSelector((state) => state?.filter);
  const [activeTab, setActiveTab] = useState(filter?.select_organic_social_platform?.platform_name ?? 'Linkedin');

  // Fetching user and filter data from redux store (you can customize this as needed)

  const dispatch=useDispatch()

  const handleTabSwitch =async (tab) => {
    try{
      setActiveTab(tab);
      setOrganicSocialMetrics([]); // Reset metrics when tab switches
      setIsMetricsLoading(true);
   
  
      //fetch posts list
      let platform_id=getPlatformNameOrId(tab);
    //  console.log(platform_id,tab)

      dispatch(UPDATE_FILTER_DATA({select_organic_social_platform:{
        platform_id:platform_id,
        platform_name:tab
      }}))

      const formData=new FormData();
      formData.append('platform_id',platform_id)
      let result=await handleApi('get_tracking_posts_list','POST',{},formData)
  
      if(result?.success)
      {
        setOrganicSocialMetrics(result?.data)
       
  
      }
      setIsMetricsLoading(false);

    }
    catch(e)
    {
      console.log(e)
    }


    // Simulate fetching metrics for the selected tab
    // setTimeout(() => {
    //   setOrganicSocialMetrics(
    //     tab === "LinkedIn"
    //       ? [
    //           {
    //             url: "https://LinkedIn.com",
    //             platform: "LinkedIn",
    //             metrics: {
    //               pageviews: 1500,
    //               clicks: 320,
    //               engagementRate: 75,
    //               bounceRate: 45,
    //             },
    //           },
    //           {
    //             url: "https://LinkedIn.com",
    //             platform: "LinkedIn",
    //             metrics: {
    //               pageviews: 150,
    //               clicks: 320,
    //               engagementRate: 75,
    //               bounceRate: 45,
    //             },
    //           },
    //         ]
    //       : tab === "Facebook"
    //       ? [
    //           {
    //             url: "https://facebook.com",
    //             platform: "Facebook",
    //             metrics: {
    //               pageviews: 2000,
    //               clicks: 400,
    //               engagementRate: 80,
    //               bounceRate: 50,
    //             },
    //           },
    //         ]
    //       : [
    //           {
    //             url: "https://instagram.com",
    //             platform: "Instagram",
    //             metrics: {
    //               pageviews: 1200,
    //               clicks: 250,
    //               engagementRate: 85,
    //               bounceRate: 40,
    //             },
    //           },
    //         ]
    //   );
     
    // }, 1000);
 
  };

  // Fetch initial metrics when component is mounted
  useEffect(() => {
    handleTabSwitch(activeTab); // Fetch metrics for the default tab (LinkedIn)

  }, []); // Empty dependency array ensures it runs only once on mount

  return (
    <>
      <Tabs activeTab={activeTab} setActiveTab={handleTabSwitch} />
      {isMetricsLoading ? (
        <LoadingSpinner />
      ) : (
        <div className="orgaic_social_card">
          <div className="orgaic_social_heading">{activeTab}</div>
          <div className="orgaic_social_body d-flex flex-column gap-3">
            {!isMetricsLoading && organicSocialMetrics?.length==0 && <div className="d-flex justify-content-center align-items-center py-4">
               <p className="chart-label fs-5">No Posts Available</p>

            </div> }

            {organicSocialMetrics.map((metricData, index) => (
              <OrganicSocialMetricsCard key={index} metricsdata={metricData} platform_id={getPlatformNameOrId(activeTab)} />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default OrganicSocialList;
const Tabs = ({ activeTab, setActiveTab }) => {
  return (
    <div className="row organic_social_tab d-flex align-items-center mb-3 flex-wrap">
      <div className="col-lg-10 col-md-12 p-0">
        <div className="d-flex gap-3">
          {/* LinkedIn Tab */}
          <span
            className={`mb-0 d-flex align-items-center gap-2 ${
              activeTab === "Linkedin" && "organic_social_tab_active"
            }`}
            onClick={() => setActiveTab("Linkedin")}
          >
            <img src={getImgSrc("linkedin")} height={20} width={20} alt="LinkedIn" />
            <span>LinkedIn</span>
          </span>

          {/* Facebook Tab */}
          <span
            className={`mb-0 d-flex align-items-center gap-2 ${
              activeTab === "Facebook" && "organic_social_tab_active"
            }`}
            onClick={() => setActiveTab("Facebook")}
          >
            <img src={getImgSrc("facebook")} height={20} width={20} alt="Facebook" />
            <span>Facebook</span>
          </span>

          {/* Instagram Tab */}
          <span
            className={`mb-0 d-flex align-items-center gap-2 ${
              activeTab === "Instagram" && "organic_social_tab_active"
            }`}
            onClick={() => setActiveTab("Instagram")}
          >
            <img src={getImgSrc("instagram")} height={20} width={20} alt="Instagram" />
            <span>Instagram</span>
          </span>
        </div>
      </div>
    </div>
  );
};
